import { __assign, __rest } from "tslib";
import React from 'react';
import { BadgeElement } from './styles';
import kinds from './kinds';
import sizes from './sizes';
export default function Badge(_a) {
    var children = _a.children, _b = _a.kind, kind = _b === void 0 ? 'default' : _b, _c = _a.size, size = _c === void 0 ? 0 : _c, _d = _a.textAlign, textAlign = _d === void 0 ? 'center' : _d, props = __rest(_a, ["children", "kind", "size", "textAlign"]);
    return (React.createElement(BadgeElement, __assign({ fontWeight: 500, textAlign: textAlign }, sizes[size], kinds[kind], props), children));
}
